import React from 'react'
import withSend from 'microcosm/addons/with-send'
import Disclaimer from './disclaimer'
import Welcome from './welcome'
import Match from 'lib/components/match'
import RA from 'ra-config'
import DisclaimerLib from 'lib/disclaimer'
import * as placeholder from 'lib/config/placeholder'

class Dialog extends React.Component {
  state = {
    isHidden: DisclaimerLib.isAccepted()
  }

  componentWillMount() {
    !this.state.isHidden && this.props.send('toggleFixed', true)
  }

  accept = e => {
    this.props.send('toggleFixed', false)
    this.setState({ isHidden: true })
    DisclaimerLib.accept()
  }

  decline = e => {
    DisclaimerLib.decline()
  }

  render() {
    if (this.state.isHidden) return null

    let text = placeholder.replace(RA.content.disclaimerText)
    let welcomeContent = RA.content.welcomeContent || []
    let slides = welcomeContent.map(content => ({
      ...content,
      image: placeholder.replace(content.image)
    }))

    return (
      <div className="overlay">
        <div className="dialog">
          <div className="dialog__cell">
            <Disclaimer
              text={text}
              onAccept={this.accept}
              onDecline={this.decline}
            />
          </div>
          <Match min="medium-min">
            <div className="dialog__cell">
              <Welcome slides={slides} />
            </div>
          </Match>
        </div>
      </div>
    )
  }
}

export default withSend(Dialog)



// WEBPACK FOOTER //
// ./src/components/welcome/dialog.js